const host = "api.erpbucket.com";
const port = "80";

export const environment = {
  name: "production",
  port,
  host,
  apiMain: `https://${host}`,
  gateway: false,
};
